import styled from "styled-components";

export const ManageScheduleStyles = styled.div`

  .cardHeaderRow {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
  }

  @keyframes fadeSlideIn {
    from {
      opacity: 0;
      transform: translateY(-50%) translateX(8px);
    }
    to {
      opacity: 1;
      transform: translateY(-50%) translateX(0);
    }
  }

  .sectionSaveBtn {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    animation: fadeSlideIn 0.25s ease-out forwards;
  }

  .tabBarSection {
    padding-bottom: ${({ theme }) => theme.spacing[16]};
  }

  .tabBar {
    position: relative;
    display: inline-flex;
    background: ${({ theme }) => theme.colors.primary[100]};
    border-radius: ${({ theme }) => theme.radius[24]};
    padding: ${({ theme }) => theme.spacing[4]};
  }

  .tabSlider {
    position: absolute;
    top: ${({ theme }) => theme.spacing[4]};
    bottom: ${({ theme }) => theme.spacing[4]};
    left: ${({ theme }) => theme.spacing[4]};
    width: calc(50% - ${({ theme }) => theme.spacing[4]});
    background: ${({ theme }) => theme.colors.accent[500]};
    border-radius: ${({ theme }) => theme.radius[24]};
    box-shadow: ${({ theme }) => theme.shadows.card};
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 0;

    &.right {
      transform: translateX(100%);
    }
  }

  .tabPill {
    position: relative;
    z-index: 1;
    padding: 8px 24px;
    border-radius: ${({ theme }) => theme.radius[24]};
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    cursor: pointer;
    transition: color 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    background: transparent;
    user-select: none;

    &.active {
      color: #ffffff;
    }
  }

  .body {
    padding: ${({ theme }) => theme.spacing[24]};
    padding-top: ${({ theme }) => theme.spacing[20]};
  }
`;
